export const processEnum = Object.freeze({
	None: 0,
	EditGrid: 1,
	DebugInitialDataSeed: 2,
	DataImport: 3,
	InventoryForm: 4,
});
